export default __webpack_public_path__ + "images/6342ee66f1a834bdeae64226bbed9b84.svg";